<template>
  <pop-up-prevention
    :messHeader="$t('detailClient.popupDeleteTiers.title', { name: tiers.nomCommercial })"
    :messDescription="$t('detailClient.popupDeleteTiers.mssgValidation')"
    :cancel="$t('general.non')"
    :validate="$t('general.oui')"
    :messagesPopup="messages"
    :messagesChampsVide="messagesChampsVide"
    :champsVide="champsVide"
    :isErrorPopup.sync="error"
    @no="$parent.close()"
    @yes="appliquer">
  </pop-up-prevention>
</template>

<script>
import { deleteTiersAsync } from '@/api/tiers';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import validationGeneral from '@/services/validation/validation';
import validationDeleteTiers from '@/services/tiers/validationDeleteTiers';

export default {
  name: 'popupDeleteTiers',
  components: {
    popUpPrevention,
  },
  props: {
    tiers: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
    };
  },
  methods: {
    async appliquer() {
      const loadingComponent = this.$buefy.loading.open();
      this.error = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      try {
        await deleteTiersAsync(this.tiers.id);
        messageSuccess(this.$i18n.t('detailClient.popupDeleteTiers.mssgDeleteSuccess'));
        this.$emit('refresh');
        this.$parent.close();
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          validationDeleteTiers(e.response, this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
